import { render, staticRenderFns } from "./SuccessfulCase.vue?vue&type=template&id=38f74752&scoped=true&"
import script from "./SuccessfulCase.vue?vue&type=script&lang=js&"
export * from "./SuccessfulCase.vue?vue&type=script&lang=js&"
import style0 from "./SuccessfulCase.vue?vue&type=style&index=0&id=38f74752&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f74752",
  null
  
)

export default component.exports